import { Injectable } from '@angular/core';

@Injectable()
export class LoggerService {

  constructor() {
    // this.info('Logger is ready...');
  }

  public info(text: any) {
    console.log(text);
  }

  public warn(text: any) {
    console.warn(text);
  }

  public error(text: any) {
    console.error(text);
  }
}
